import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import './CreditCardDetails.css';
import copyTextToClipBoard from '../../utility/Clipboard';
import Enums from '../../constants/Enums';
import States from '../../constants/States';

const {
  localStorageKeys,
  paymentDetailsEnum,
} = Enums;
const { paymentDetailsStates } = States;


// const renderNewStructureCard = (d) => {
//   const expiry = `${d.expiryMonth}/${d.expiryYear}`;
//   return (
//     <div key={v4()}>
//       <div className="credit-card-detail-container">
//         {/* <div className="credit-card-button-container">
//           <div>
//             Token:
//             <span>
//               &nbsp;
//             </span>
//             {d.paymentToken}
//           </div>
//           <Button className="credit-card-button" value={d.paymentToken} onClick={e => copyTextToClipBoard(e)}>
//             Copy
//           </Button>
//         </div> */}
//         <div className="credit-card-button-container">
//           <div>
//             Mask:
//             <span>
//               &nbsp;
//             </span>
//             {d.maskedCard || d.mask}
//           </div>
//           {/* <Button className="credit-card-button" value={d.maskedCard} onClick={e => copyTextToClipBoard(e)}>
//             Copy
//           </Button> */}
//         </div>
//         <div className="credit-card-type-container">
//           cardType:
//           <span>
//             &nbsp;
//           </span>
//           {d.cardType || "Null"}
//         </div>        
//         <div className="credit-card-button-container">
//           <div>
//             Expiry Date:
//             <span>
//               &nbsp;
//             </span>
//             {expiry}
//           </div>
//           {/* <Button className="credit-card-button" value={expiry} onClick={e => copyTextToClipBoard(e)}>
//             Copy
//           </Button> */}
//         </div>
//         <div className="credit-card-type-container">
//           Status:
//           <span>
//             &nbsp;
//           </span>
//           {d.status}
//         </div>
//       </div>
//     </div>
//   );
// };
// 
const renderNewStructureCard = (d) => {
  if (!d) return null;

  const expiry = d?.expiryMonth && d?.expiryYear
    ? `${d.expiryMonth}/${d.expiryYear}`
    : "N/A";

  const key = d.id || d.token || d.mask;

  if (d.domain) {
    return (
      <div key={key} className="credit-card-detail-container">
        <div className="credit-card-button-container">
          <div>
            Token:&nbsp;{d.token}
          </div>
          <Button onClick={() => copyTextToClipBoard(d.token)}>
            Copy
          </Button>
        </div>

        <div className="credit-card-button-container">
          <div>
            Mask:&nbsp;{d.mask}
          </div>
          <Button onClick={() => copyTextToClipBoard(d.mask)}>
            Copy
          </Button>
        </div>

        <div className="credit-card-type-container">
          Type:&nbsp;{d.type}
        </div>
      </div>
    );
  }

  return (
    <div key={key} className="credit-card-detail-container">
      <div className="credit-card-button-container">
        <div>
          Mask:&nbsp;{d.maskedCard || d.mask}
        </div>
      </div>

      <div className="credit-card-type-container">
        Card Type:&nbsp;{d.cardType || "N/A"}
      </div>

      <div className="credit-card-button-container">
        <div>
          Expiry Date:&nbsp;{expiry}
        </div>
      </div>

      <div className="credit-card-type-container">
        Status:&nbsp;{d.status}
      </div>
    </div>
  );
};
// 

const formatCardDetails = () => {
  const cachedObject = JSON.parse(window.localStorage.getItem(
    localStorageKeys.CREDIT_CARD_DETAILS_CACHE,
  ));
  if (!cachedObject || cachedObject[paymentDetailsEnum.DETAILS_LIST] == null) {
    return wrappedMessage(paymentDetailsEnum.EMPTY_MESSAGE);
  }
  const parsed = JSON.parse(cachedObject[paymentDetailsEnum.DETAILS_LIST]);
  if (!parsed) {
    return wrappedMessage(paymentDetailsEnum.EMPTY_MESSAGE);
  }
  const details = Array.isArray(parsed) ? parsed : [parsed];
  if (details.length === 0) {
    return wrappedMessage(paymentDetailsEnum.EMPTY_MESSAGE);
  }

  // New structure: items have paymentToken instead of domain/token
  if (details[0]) {
    const returnValue = details.map(d => renderNewStructureCard(d));
    if (returnValue.length === 0) {
      return wrappedMessage(paymentDetailsEnum.EMPTY_MESSAGE);
    }
    return returnValue;
  }

  // Legacy structure: filter by domain (HW/HS type), or show all if CURRENT_TYPE not set
  const currentType = cachedObject[paymentDetailsEnum.CURRENT_TYPE];
  const returnValue = details.filter((item) => {
    if (!currentType) return true;
    if (currentType === paymentDetailsEnum.HW_TYPE && item.domain === paymentDetailsEnum.HW_TYPE) {
      return true;
    }
    if (currentType === paymentDetailsEnum.HS_TYPE && item.domain === paymentDetailsEnum.HS_TYPE) {
      return true;
    }
    return false;
  }).map((d) => {
    if (d.domain === paymentDetailsEnum.HS_TYPE) {
      return (
        <div key={v4()}>
          <div className="credit-card-detail-container">
            <div className="credit-card-button-container">
              <div>
                Token:
                <span>
                  &nbsp;
                </span>
                {d.token}
              </div>
              <Button className="credit-card-button" value={d.token} onClick={e => copyTextToClipBoard(e)}>
                Copy
              </Button>
            </div>
            <div className="credit-card-button-container">
              <div>
                Mask:
                <span>
                  &nbsp;
                </span>
                {d.mask}
              </div>
              <Button className="credit-card-button" value={d.mask} onClick={e => copyTextToClipBoard(e)}>
                Copy
              </Button>
            </div>
            <div className="credit-card-type-container">
              Type:
              <span>
                &nbsp;
              </span>
              {d.type}
            </div>
          </div>
        </div>
      );
    }
    if (d.domain === paymentDetailsEnum.HW_TYPE) {
      return (
        <div key={v4()}>
          <div className="credit-card-detail-container">
            <div className="credit-card-button-container">
              <div>
                Token:
                <span>
                  &nbsp;
                </span>
                {d.token}
              </div>
              <Button className="credit-card-button" value={d.token} onClick={e => copyTextToClipBoard(e)}>
                Copy
              </Button>
            </div>
            <div className="credit-card-button-container">
              <div>
                Mask:
                <span>
                  &nbsp;
                </span>
                {d.mask}
              </div>
              <Button className="credit-card-button" value={d.mask} onClick={e => copyTextToClipBoard(e)}>
                Copy
              </Button>
            </div>
            <div className="credit-card-button-container">
              <div>
                Expiry Date:
                <span>
                  &nbsp;
                </span>
                {d.expiry}
              </div>
              <Button className="credit-card-button" value={d.expiry} onClick={e => copyTextToClipBoard(e)}>
                Copy
              </Button>
            </div>
            <div className="credit-card-type-container">
              Type:
              <span>
                &nbsp;
              </span>
              {d.type}
            </div>
          </div>
        </div>
      );
    }
  //   else{
  //       if (!d) return null;

  // const expiry = d?.expiryMonth && d?.expiryYear
  //   ? `${d.expiryMonth}/${d.expiryYear}`
  //   : "N/A";

  // const key = d.id || d.token || d.mask;
  //       return (
  //   <div key={key} className="credit-card-detail-container">
  //     <div className="credit-card-button-container">
  //       <div>
  //         Mask:&nbsp;{d.maskedCard || d.mask}
  //       </div>
  //     </div>

  //     <div className="credit-card-type-container">
  //       Card Type:&nbsp;{d.cardType || "N/A"}
  //     </div>

  //     <div className="credit-card-button-container">
  //       <div>
  //         Expiry Date:&nbsp;{expiry}
  //       </div>
  //     </div>

  //     <div className="credit-card-type-container">
  //       Status:&nbsp;{d.status}
  //     </div>
  //   </div>
  // );
  //   }
    return null;
  });
  if (returnValue.length === 0) {
    return wrappedMessage(paymentDetailsEnum.EMPTY_MESSAGE);
  }
  return returnValue;
};

const wrappedMessage = (message) => {
  const messageDetails = message;
  return (
    <div className="credit-card-message-container">
      <div className="credit-card-message">
        {messageDetails}
      </div>
    </div>
  );
};

const parseData = (data) => {
  if (data.creditCardDetails === paymentDetailsStates.DISPLAY) {
    return formatCardDetails();
  }
  switch (data.creditCardDetails) {
    case paymentDetailsStates.WAIT: return wrappedMessage(paymentDetailsEnum.WAIT_MESSAGE);
    case paymentDetailsStates.HELD: return wrappedMessage(paymentDetailsEnum.HELD_MESSAGE);
    case paymentDetailsStates.ERROR: return wrappedMessage(paymentDetailsEnum.ERROR_MESSAGE);
    case paymentDetailsStates.DROP: return wrappedMessage(paymentDetailsEnum.DROP_MESSAGE);
    case paymentDetailsStates.EXIT: return wrappedMessage(paymentDetailsEnum.EXIT_MESSAGE);
    default: return wrappedMessage(paymentDetailsEnum.EMPTY_MESSAGE);
  }
};

const CreditCardDetails = ({
  creditCardDetails,
}) => {
  const [paymentDetails, setPaymentDetails] = useState(paymentDetailsStates.EMPTY);
  useEffect(() => {
    setPaymentDetails(parseData(creditCardDetails));
  }, [creditCardDetails]);
  return (
    <div>
      {paymentDetails}
      {/* <Button className="credit-card-button" onClick={creditCardDetails.fetchPaymentDetails}>
        Get Token
      </Button> */}
    </div>
  );
};

CreditCardDetails.propTypes = {
  creditCardDetails: PropTypes.shape().isRequired,
};

export default CreditCardDetails;
